<div class="modal-container" *transloco="let t; prefix: 'parts.modals'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('approveParts.title') }}</span>
  </div>

  <div class="modal-container__body">
    <p class="modal-subtitle">{{ t('approveParts.subtitle') }}</p>

    <div class="work-orders-list">
      <div class="work-order-section">
        <span class="work-order-number">{{ workOrderNumber }}</span>
        <div class="parts-card">
          @for (part of parts; track part.partNumber) {
            <div class="part-row">
              <div class="part-field">
                <span class="part-label">{{ t('fields.partNumberColon') }}</span>
                <span class="part-value">{{ part.partNumber }}</span>
              </div>
              <div class="part-field">
                <span class="part-label">{{ t('fields.descriptionColon') }}</span>
                <span class="part-value">{{ part.category }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="modal-actions">
    <button class="modal-btn cancel" (click)="closeModal()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>
    <button class="modal-btn approve" [disabled]="isLoading" (click)="onApprove()">
      @if (isLoading) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        <span>{{ t('approveParts.title') }}</span>
      }
    </button>
  </div>
</div>